const data = {
  1 : {
    type: "A",
    videoId: "9f5EsU_5ItM",
    imageFile: "a",
    specialContracts: ["01","06"],
    sex: "female"
  },
  2 : {
    type: "B",
    videoId: "JahPGw6dlYU",
    imageFile: "b",
    specialContracts: ["02","06"],
    sex: "female"
  },
  3 : {
    type: "C",
    videoId: "GCH43KU60qs",
    imageFile: "c",
    specialContracts: ["03","06"],
    sex: "female"
  },
  4 : {
    type: "D",
    videoId: "MpwQUisKxHU",
    imageFile: "d",
    specialContracts: ["01","05","06"],
    sex: "female"
  },
  5 : {
    type: "E",
    videoId: "yl5fjvC3IUk",
    imageFile: "e",
    specialContracts: ["01","05","06"],
    sex: "female"
  },
  6 : {
    type: "F",
    videoId: "5_L1RXHTJJU",
    imageFile: "f",
    specialContracts: ["03","05","06"],
    sex: "female"
  },
  7 : {
    type: "G",
    videoId: "SJS-yyiHCu4",
    imageFile: "g",
    specialContracts: ["03","06"],
    sex: "male"
  },
  8 : {
    type: "H",
    videoId: "dwSQw9eT1mk",
    imageFile: "h",
    specialContracts: ["01","06"],
    sex: "male"
  },
  9 : {
    type: "I",
    videoId: "j9LMh_e-nRg",
    imageFile: "i",
    specialContracts: ["03","05","06"],
    sex: "male"
  },
  10 : {
    type: "J",
    videoId: "fWu-iMAjj54",
    imageFile: "j",
    specialContracts: ["01","05","06"],
    sex: "male"
  }
}
class Result {
  constructor(data){
    this.data = data;
  }
  getVideoFileById(id){
    const data = this.data;
    return data[id].videoFile ? data[id].videoFile : null;
  }
  getVideoIdById(id){
    const data = this.data;
    return data[id].videoId ? data[id].videoId : null;
  }
  getImageFileById(id){
    const data = this.data;
    return data[id].imageFile ? data[id].imageFile : null;
  }
  getTypeById(id){
    const data = this.data;
    return data[id].type ? data[id].type : null;
  }
  getSpecialContractsById(id){
    const data = this.data;
    return data[id].specialContracts ? data[id].specialContracts : null;
  }
  getSexById(id){
    const data = this.data;
    return data[id].sex ? data[id].sex : null;
  }
}

export default new Result(data)